import './ExitGamePageConfirm.css';
import React from 'react';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';

export const ExitGamePageConfirm = ({
    closePopupHandler,
    ctaActionHandler,
    ctaText,
}) => {
    const { t } = useTranslations();

    return (
        <>
            <div className="game-page-exit-confirm">
                <div className="game-page-exit-confirm__text">{t('areYouSure')}</div>
                <div
                    className="game-page-exit-confirm__cta"
                    onClick={ctaActionHandler}
                >{ctaText}</div>
            </div>

            <div
                className="game-page-exit-confirm__overlay"
                onClick={closePopupHandler}
            />
        </>
    );
};
